import _taggedTemplateLiteral from "/usr/src/app/client/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/taggedTemplateLiteral";

var _templateObject;

import React from "react";
import { array } from "prop-types";
import Styled from "styled-components";
import { AccordianItem, AccordianHeader, AccordianContent } from "./";
var AccordianStyle = Styled.div(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n\n"])));
export var Accordian = function Accordian(_ref) {
  var className = _ref.className,
      content = _ref.content;
  var accordian = content.map(function (item, index) {
    return /*#__PURE__*/React.createElement(AccordianItem, {
      key: index
    }, /*#__PURE__*/React.createElement(AccordianHeader, null, item.header), /*#__PURE__*/React.createElement(AccordianContent, null, item.content));
  });
  return /*#__PURE__*/React.createElement(AccordianStyle, {
    className: className
  }, accordian);
}; // array, bool, func, number, object, string
// symbol, node, element, elementType
// instanceOf oneOf oneOfType shape, exact, func, any

Accordian.propTypes = {
  content: array.isRequired
};
Accordian.defaultProps = {};